import { Group } from '@gripp/shared-logic';
import { useState } from 'react';
import { View } from 'react-native';
import { Chip, Menu } from 'react-native-paper';
import { GroupChip, useGroupChipStyle, getGroupChipTextStyle } from './groupChip';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

type GroupChipMenuProps = {
  groups: Group[];
  onPress?: (groupId: string) => Promise<void>;
  chipLength?: number;
};

export const GroupChipMenu = (props: GroupChipMenuProps) => {
  const chipStyle = useGroupChipStyle();
  const [visible, setVisible] = useState(false);
  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  const onPress = async (groupId: string) => {
    if (props.onPress) {
      await props.onPress(groupId);
      closeMenu();
    }
  };

  return (
    <Menu
      visible={visible}
      onDismiss={closeMenu}
      contentStyle={styles.groupMenuContent}
      anchor={
        <Chip
          onPress={openMenu}
          textStyle={getGroupChipTextStyle()}
          style={chipStyle}
        >
          {`+${props.chipLength ?? props.groups.length - 1}`}
        </Chip>
      }
    >
      {props.groups.map((group) => (
        <View
          key={props.groups.indexOf(group)}
          style={styles.groupChipMenuItemContainer}
        >
          <GroupChip group={group} onPress={onPress} />
        </View>
      ))}
    </Menu>
  );
};

const styles = themedStyleSheet((role) => ({
  groupChipMenuItemContainer: {
    marginVertical: 5,
    marginHorizontal: 15,
  },
  groupMenuContent: {
    backgroundColor: role.surface,
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    textAlign: 'center',
    top: 30,
    right: 40,
  },
}));
